import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { GuardService } from '../services/guard.service';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard implements CanActivate {
  
  constructor(private guardService:GuardService,
    private router:Router,
    ){}
   canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      console.log(route);
      var token = route.queryParams['q'];
      console.log(token);
      if(!token){
        token = route.params['q'];
      }
      return new Promise ((resolve) => {
        this.guardService.validateCredentials(token).then((res) => {
          if(res){
            resolve(true)
          }else{
            window.location.href = 'https://masgarantia.liverpool.com.mx/'
            resolve(false)
          }
        })
      })
  }
  
}
